export default {
  PASSWORD: {
    REGEX: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^*+=-])[A-Za-z\d!@#$%^*+=-]{8,16}$/,
    MSG: '비밀번호는 영문, 숫자, 특수문자(!@#$%^*+=-) 조합 6~15자로 입력해주세요.',
  },
  PHONE: {
    REGEX: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
    MSG: '휴대폰 번호가 유효하지 않습니다.',
  },
  BIRTH: {
    REGEX: /^(19[0-9][0-9]|20\d{2})-?(0[0-9]|1[0-2])-?(0[1-9]|[1-2][0-9]|3[0-1])$/,
    MSG: '생년월일이 유효하지 않습니다.',
  },
  DATE: {
    REGEX: /^(19[0-9][0-9]|20\d{2})-?(0[0-9]|1[0-2])-?(0[1-9]|[1-2][0-9]|3[0-1])$/,
    MSG: '발급일자가 유효하지 않습니다.',
  },
  EMAIL: {
    REGEX: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    MSG: '이메일 주소가 유효하지 않습니다.',
  },
  LICENSENUMBER: {
    REGEX: /^[0-9].{9}$/,
    MSG: '사업자등록번호가 유효하지 않습니다.',
  },
  JUMIN1: {
    REGEX: /\d{6}/,
    MSG: '주민번호가 유효하지 않습니다',
  },
  JUMIN2: {
    REGEX: /[1-4]\d{6}/,
    MSG: '주민번호가 유효하지 않습니다',
  },
  URL: {
    // REGEX: /^(file|gopher|news|nntp|telnet|https?|ftps?|sftp):\/\/([a-z0-9-]+\.)+[a-z0-9]{2,4}.*$/,
    REGEX: /^([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,4}.*$/,
    MSG: '쇼핑몰 URL이 유효하지 않습니다.',
  },
  NUMBERIC: {
    REGEX: /^[0-9.]+$/,
    MSG: '숫자만 입력해주세요.',
  },
  NOT_NUMBERIC: {
    REGEX: /[^0-9]/,
    MSG: '숫자는 입력하지 마세요.',
  },
  NAME: {
    REGEX: /^[가-힣]{2,5}$/,
    MSG: '이름이 유효하지 않습니다.',
  },
  ACCOUNTNUMBER: {
    REGEX: /^[0-9]{4,}$/,
    MSG: '계좌번호가 유효하지 않습니다.',
  },
}
